import en from './lang/en';
import de from './lang/de';
import fr from './lang/fr';
import pt from './lang/pt';
import ca from './lang/ca';
import cn from './lang/cn';
import it from './lang/it';
import es from './lang/es';
import th from './lang/th';
import id from './lang/id';
import sv from './lang/sv';
import ru from './lang/ru';
import ptbr from './lang/pt-br';
import hu from './lang/hu';
import pl from './lang/pl';
import he from './lang/he';
import ja from './lang/ja';
import zhtw from './lang/zh-tw';
import nl from './lang/nl';
import lt from './lang/lt';
import tr from './lang/tr';
import ko from './lang/ko';
import el from './lang/el';

export const terms = {
    en,
    de,
    fr,
    pt,
    ca,
    cn,
    it,
    es,
    th,
    'pt-br': ptbr,
    ru,
    sv,
    id,
    hu,
    pl,
    ja,
    nl,
    he,
    'zh-tw': zhtw,
    lt,
    tr,
    ko,
    el
};
